import { PaginationT } from 'models/Pagination'

import { api } from '../index'

export interface UserListUser {
  id: number
  uid: string
  email: string
  first_name: string
  last_name: string
}

interface GetCustomersResponse {
  users: UserListUser[]
  pagination: PaginationT
}

interface GetCustomersParams {
  userListId: number
  page?: number
  per_page?: number
  query?: string
}

export const userListCustomersApi = api.injectEndpoints({
  endpoints: builder => ({
    getUserListCustomers: builder.query<
      { data: UserListUser[]; pagination: PaginationT },
      GetCustomersParams
    >({
      query: ({ userListId, ...params }) => ({
        url: `user_lists/${userListId}/customers`,
        method: 'GET',
        params,
      }),
      transformResponse: (response: GetCustomersResponse) => ({
        data: response.users || [],
        pagination: response.pagination,
      }),
      providesTags: (_result, _error, { userListId }) => [
        { type: 'UserList', id: `${userListId}-customers` },
      ],
    }),
  }),
})

export const { useGetUserListCustomersQuery } = userListCustomersApi
